// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2ebf379c","239":"484faaf5","455":"a8e53ed0"}[chunkId] + ".chunk.js";
};